import React from 'react';
import { ReactComponent as FigXCloseComponent } from './FigXClose.svg';

const FigXClose = (props) => <FigXCloseComponent {...props} />;

export default FigXClose;
